export default {
  "content": "<path d=\"M10 19a1 1 0 011 1v2H9v-1H5v1H3v-2a1 1 0 011-1h6zM20 19a1 1 0 011 1v2h-2v-1h-4v1h-2v-2a1 1 0 011-1h6z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10 8a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1V9a1 1 0 011-1h6zm-5 6h4v-4H5v4zM20 8a1 1 0 011 1v6a1 1 0 01-1 1h-6a1 1 0 01-1-1V9a1 1 0 011-1h6zm-5 6h4v-4h-4v4z\" fill=\"#7B61FF\"/><path d=\"M5 3h4V2h2v2a1 1 0 01-1 1H4a1 1 0 01-1-1V2h2v1zM15 3h4V2h2v2a1 1 0 01-1 1h-6a1 1 0 01-1-1V2h2v1z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};